
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    wishes: {
      type: Number,
      required: true,
    },
    fates: {
      type: Number,
      required: true,
    },
    standard: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["try-wish"],
  methods: {
    play() {
      (this.$refs.textClickAudio as HTMLAudioElement).play();
      this.$emit(`try-wish`, this.wishes);
    },
  },
});
